export default {
  name: "NotFound",
};
